// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"FooterContact_sectionContainer__v10GF"};